import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import selectDropdown from "../../../../custom/SelectDropdown";
import { MasterApi } from "../../../../App/api/setting";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import CustomModal from "../../../../custom/modal/customModal";
import { MdDelete } from "react-icons/md";
const AddTaxModal = ({ isOpen, onClose, data, fetchAllData }) => {
  // Fetch country data
  const { data: countryData } = useSelector((state) => state.country);

  // console.log("countrydata", countryData);

  // Generate options for the select dropdown
  const options = selectDropdown(countryData, "_id", "name");

  // Initialize formik
  const formik = useFormik({
    initialValues: {
      name: "",
      rate: "",
      country: {}, // Store the entire country object
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Name is required"),
      rate: Yup.number()
        .typeError("Rate must be a number")
        .min(1, "Rate must be at least 1")
        .max(50, "Rate must be 5 or less")
        .required("Rate is required"),
      country: Yup.object()
        .shape({
          _id: Yup.string().required("Country is required"),
          name: Yup.string().required("Country is required"),
        })
        .required("Country is required"),
    }),
    onSubmit: async (values) => {
      const payload = {
        ...values,
        country: values.country._id, // Send only the country ID
      };
      // console.log("Form data", payload);

      try {
        if (data?._id) {
          const res = await MasterApi.master.updateTaxMaster(
            data?._id,
            payload
          );
          // console.log("res", res);
          toast.success("Updated tax successfully");
          fetchAllData();
        } else {
          const res = await MasterApi.master.createTaxMaster(payload);
          toast.success("Created tax successfully");
          fetchAllData();
          // console.log("res", res);
        }
      } catch (err) {
        // console.log(err);
      }

      handleClose(); // Close the modal after form submission
    },
  });

  // Update formik values when the data prop changes
  useEffect(() => {
    if (data) {
      formik.setValues({
        name: data?.name || "",
        rate: data?.rate ? parseFloat(data.rate.$numberDecimal) : "",
        country: data?.Country || {},
      });
    }
  }, [data, isOpen]);

  const handleClose = () => {
    formik.resetForm(); // Reset the form when closing
    onClose();
  };

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm(); // Reset the form when the modal is closed
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <CustomModal isOpen={isOpen} onClose={handleClose} title="Add Details">
      <form onSubmit={formik.handleSubmit} className="mt-4">
        <div className="mb-4">
          <label className="block text-gray-700">Name</label>
          <input
            type="text"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`mt-1 p-2 block w-full border ${
              formik.touched.name && formik.errors.name
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          />
          {formik.touched.name && formik.errors.name && (
            <p className="text-red-500 text-sm mt-1">{formik.errors.name}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Rate %</label>
          <input
            type="number"
            name="rate"
            value={formik.values.rate || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`mt-1 p-2 block w-full border ${
              formik.touched.rate && formik.errors.rate
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          />
          {formik.touched.rate && formik.errors.rate && (
            <p className="text-red-500 text-sm mt-1">{formik.errors.rate}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Country</label>
          <select
            name="country"
            value={formik.values.country._id || ""}
            onChange={(e) => {
              const selectedCountry = countryData?.find(
                (country) => country._id === e.target.value
              );
              formik.setFieldValue("country", selectedCountry || {});
            }}
            onBlur={formik.handleBlur}
            className={`mt-1 p-2 block w-full border ${
              formik.touched.country && formik.errors.country
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          >
            <option value="" label="Select a country" />
            {options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                label={option.label}
              />
            ))}
          </select>
          {formik.touched.country && formik.errors.country && (
            <p className="text-red-500 text-sm mt-1">
              {formik.errors.country._id}
            </p>
          )}
        </div>
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            className={` bg-gray-500
          text-white px-4 py-2 rounded hover:bg-gray-600`}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-[#e34e4e] text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </form>
    </CustomModal>
  );
};

export default AddTaxModal;
